<template>
  <select @change="update" v-model="selectedCityId" class="custom-select">
    <option value="all">Все города</option>
    <option v-for="city in cities.part1" :value="city.id">{{ city.name }}</option>
    <optgroup label="-----">
    </optgroup>
    <option v-for="city in cities.part2" :value="city.id">{{ city.name }}</option>
  </select>
</template>

<script>
export default {
  props: ['onUpdate'],
  data() {
    return {
      cities: {
        part1: [],
        part2: []
      },
      selectedCityId: 'all'
    }
  },
  computed: {
    $AllCities() {
      const cities = this.$store.getters['platform/cities'];
      cities[0] = {
        name: 'Почта',
        id: 0
      };
      return cities;
    },
  },
  mounted() {
    const cities = Object.values(this.$AllCities);
    this.cities.part1.push(cities.find((c) => c.id === 1));
    this.cities.part1.push(cities.find((c) => c.id === 2));
    this.cities.part1.push({id: 0, name: 'Почта'});
    const arr = cities.filter((c) => ![1, 2].includes(c.id));
    this.cities = {
      part1: [...this.cities.part1],
      part2: [..._.orderBy(arr, 'name')]
    };
  },
  methods: {
    update(e) {
      if (this.onUpdate) {
        this.onUpdate(this.selectedCityId);
      }
    }
  }
}
</script>
